import { render, staticRenderFns } from "./inputTypeRadioGroup.vue?vue&type=template&id=3694b3d0&scoped=true"
import script from "./inputTypeRadioGroup.vue?vue&type=script&lang=js"
export * from "./inputTypeRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694b3d0",
  null
  
)

export default component.exports